export enum ContactTypeFilterValue {
	All = "all",
	Internal = "internal",
	External = "external",
}

export interface ContactTypeFilterProps {
	value: ContactTypeFilterValue;
	onChange: (value: ContactTypeFilterValue) => void;
	disabled?: boolean;
}
